import type { MenuListOption } from './MenuList';

/**
 * Option input accepted by `Select` / `MultiSelect`: either plain strings
 * (value and label are the same) or full option objects.
 */
export type SelectOptionInput = string | MenuListOption;

/**
 * Normalizes the caller's options to `MenuListOption[]`.
 * A plain string becomes `{ value: s, label: s }`, so simple lists can be
 * passed as `['EV', 'Carpool']` without building objects.
 */
export function normalizeOptions(options: readonly SelectOptionInput[]): MenuListOption[] {
  return options.map((option) =>
    typeof option === 'string' ? { value: option, label: option } : option
  );
}
